<template>
  <sf-modal
    v-if="showModal"
    class-name="sf-modal sf-modal-xs"
    hide-close="true"
    @close="closeModal"
  >
    <template #title>
      {{ modalTitle }}
    </template>
    <template #body>
      <div class="sf-pad-h-4">
        <div class="sf-below-2">
          <span v-dompurify-html="modalInfoLabel1"></span>
        </div>
        <div class="sf-below-2">
          <span v-dompurify-html="modalInfoLabel2"></span>:
        </div>
        <div class="sf-below-1">
          <span class="sf-icon sf-font-l icon-check-circle sf-c-success"></span>
          {{ modalListItem1 }}
        </div>
        <div class="sf-below-1">
          <span class="sf-icon sf-font-l icon-check-circle sf-c-success"></span>
          {{ modalListItem2 }}
        </div>
        <div class="sf-below-1">
          <span class="sf-icon sf-font-l icon-check-circle sf-c-success"></span>
          {{ modalListItem3 }}
        </div>
        <div class="sf-below-4">
          <span class="sf-icon sf-font-l icon-check-circle sf-c-success"></span>
          {{ modalListItem4 }}
        </div>
        <div class="sf-below-1 sf-level sf-level-center">
          <a
            class="sf-btn sf-btn-success"
            data-heap="premium-cr-ok"
            @click="closeModal"
          >
            {{ modalOkButton }}
          </a>
        </div>
      </div>
    </template>
  </sf-modal>
</template>

<script type="text/javascript">
import { SfModal } from '@app/shared/vue/components/sf-modal'

export default {
  name: 'CustomReportingModal',
  components: { SfModal },
  data() {
    return {
      showModal: true,
    }
  },
  computed: {
    modalTitle() {
      return I18n.t('shared.premium_feature')
    },

    modalInfoLabel1() {
      return I18n.t('reporting_tiers.custom_reporting_modal.info_1')
    },

    modalInfoLabel2() {
      return I18n.t('reporting_tiers.custom_reporting_modal.info_2')
    },

    modalListItem1() {
      return I18n.t('reporting_tiers.custom_reporting_modal.list_1')
    },

    modalListItem2() {
      return I18n.t('reporting_tiers.custom_reporting_modal.list_2')
    },

    modalListItem3() {
      return I18n.t('reporting_tiers.custom_reporting_modal.list_3')
    },

    modalListItem4() {
      return I18n.t('reporting_tiers.custom_reporting_modal.list_4')
    },

    modalOkButton() {
      return I18n.t('reporting_tiers.custom_reporting_modal.ok_button')
    },
  },
  methods: {
    openModal() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
  },
}
</script>
